import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';
import { RT_ON_TRENDS_EXCLUDE_LIST } from '@utils/metrics';
import { realTimeModeOnTrendsSelector } from '@store/common/selectors';

const selector = (state) => state[SCOPE];

export default selector;

/**
 * return { [dimensionName]: { [metricName]: [number]}}
 */
export const dimensionsTotalsSelector = createSelector(selector, (dimensionTablesStore) => {
  const { dimensions } = dimensionTablesStore;
  const dimensionNames = Object.keys(dimensions);
  if (dimensionNames.length === 0) {
    return {};
  }
  return dimensionNames.reduce((totals, currentDimensionName) => {
    const mirrorTotals = totals;
    mirrorTotals[currentDimensionName] =
      get(dimensions, `${currentDimensionName}.response.totals[0].results`) || {};
    return mirrorTotals;
  }, {});
});

export const metricsSelector: any = createSelector(
  selector,
  realTimeModeOnTrendsSelector,
  (dimensionTablesStore, realTimeOnTrends) => {
    const { dimensionSortByMetric } = dimensionTablesStore;
    let { metrics } = dimensionTablesStore;
    if (realTimeOnTrends) {
      metrics = metrics.filter((metric) => !RT_ON_TRENDS_EXCLUDE_LIST.includes(metric));
    }
    if (!metrics.includes(dimensionSortByMetric)) {
      return [...metrics, dimensionSortByMetric];
    }

    return metrics;
  },
);

export const dimensionsDataSelector = createSelector(selector, (dimensionTablesStore) => {
  const { dimensions } = dimensionTablesStore;

  const dataObj = {};
  Object.keys(dimensions).forEach((dimensionName) => {
    dataObj[dimensionName] = get(dimensions, `${dimensionName}.response.data[0].results`, []);
  });
  return dataObj;
});

export const dimensionNamesSelector = createSelector(selector, (dimensionTablesStore) => {
  const { dimensions } = dimensionTablesStore;
  return Object.keys(dimensions).sort((prev, current) => {
    const prevSort = get(dimensions, `${prev}.sort`);
    const currentSort = get(dimensions, `${current}.sort`);
    if (prevSort < currentSort) {
      return -1;
    }
    return 1;
  });
});

export const dimensionSelector = createSelector(
  selector,
  dimensionNamesSelector,
  (_, props) => props,
  (dimensionTablesStore, dimensionNames, props) => {
    const { index } = props;
    const { dimensions } = dimensionTablesStore;
    return get(dimensions, dimensionNames[index < dimensionNames.length ? index : 0]);
  },
);

export const currentDimensionsSelector = createSelector(selector, (dimensionTablesStore) => {
  const { dimensions } = dimensionTablesStore;
  return Object.keys(dimensions).sort((a, b) => dimensions[a].sort - dimensions[b].sort);
});

export const dimensionSortByMetricSelector = createSelector(
  selector,
  (state) => state.dimensionSortByMetric,
);

export const dimensionTableHeaderIntervalSelector = createSelector(
  selector,
  (state) => state.dimensionTableHeaderInterval,
);
